<template>
  <div class="ky-detail">
    <ul>
      <li class="exercise" v-for="(exercise, index) in exercises" :key="exercise.id">
        <div class="exercise-wrap">
          <p>{{ index + 1 }}.{{ exercise.explain || '暂无解释' }}</p>
          <p>
            <van-speaker class="small primary"
                         @click.native="playAudio(exercise.audio)" />
            &nbsp;
            <span v-html="setStyleText(exercise)"></span>
          </p>
        </div>
        <div class="operation">
          <span class="audio">
            <van-speaker class="small primary"
                         @click.native="playAudio(exercise.record)" />
            我的
          </span>
          <van-score :score="exercise.score"></van-score>
        </div>
      </li>
    </ul>
    <p class="score-wrap">
      <span>整体评分</span>
      <van-score :score="score"></van-score>
      <span v-if="!isPass && isRepeat">
        <el-button size="mini" type="danger" round @click="again">再测一次</el-button>
      </span>
    </p>
    <div class="tip">
      <p v-if="isPass">
        太棒啦，恭喜你已完成本文的学习！
        <br />
        <br />
        <el-button size="mini"
                   type="primary"
                   @click="handleContinue"
                   v-if="isContinue"
                   round
        >
          进入下一题
        </el-button>
        <el-button size="mini" type="danger" round @click="exit" v-else>退出</el-button>
      </p>
      <p v-else>
        <template v-if="isRepeat">
          太遗憾，你在本次 "人机对话" 的表现没有达到优秀水平。
          <template v-if="isFinish">系统要求你进行【强化学习】，</template><br />
          您<template v-if="isFinish">也</template>可以 【再测一次】让系统重新评估你的成绩。
        </template>
        <template v-else>
          太遗憾，你再次测试的表现没有达到优秀水平。系统要求你进行【强化学习】。
        </template>
        <br />
        <br />
        <el-button size="mini"
                   type="primary"
                   round
                   v-if="isFinish && !isPass"
                   @click="submit">
          强化学习
        </el-button>
        <el-button size="mini"
                   type="primary"
                   @click="handleContinue"
                   v-else
                   round
        >
          进入下一题
        </el-button>
      </p>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui';
import VanScore from 'vanthink-components/components/common/Score.vue';
import VanSpeaker from 'vanthink-components/components/common/Speaker.vue';
import utils from '@/services/utils';
import AudioPlayer from '@/services/audio-player';

export default {
  components: {
    VanScore,
    ElButton: Button,
    VanSpeaker,
  },
  props: {
    exercises: {
      type: Array,
      default: () => ({}),
    },
    times: {
      type: Number,
      default: 0,
    },
    isContinue: {
      type: Boolean,
      default: false,
    },
    isPass: {
      type: Boolean,
      default: false,
    },
    score: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFinish: false,
    };
  },
  computed: {
    isRepeat() {
      return !this.times;
    },
  },
  methods: {
    playAudio(url) {
      AudioPlayer.play(url);
    },
    again() {
      this.$emit('again');
    },
    submit() {
      this.$emit('submit');
    },
    exit() {
      this.$emit('exit');
    },
    handleContinue() {
      this.$emit('continue');
    },
    setStyleText(exercise) {
      return exercise.text.split(/\s+/)
        .map((word) => {
          const isMatch = utils.Array.exist(exercise.match, word)
            || utils.Array.exist(exercise.match, word.replace(/[.,!?](?=\B)/g, ''));
          return isMatch ? `<span class="match">${word}</span>` : word;
        })
        .join(' ');
    },
  },
  created() {
    // 数据提交后 status 会改变，这里赋给组件内属性 即依赖于最开始的状态
    this.isFinish = this.status;
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .ky-detail {
    padding: 20px;
    ul {
      li {
        border-bottom: 2px solid #eee;
        &:last-child {
          border-bottom: 2px solid transparent;
        }
      }
    }
    .exercise {
      position: relative;
      .exercise-wrap {
        p {
          font-size: 16px;
        }
        margin-right: 300px;
        i {
          cursor: pointer;
          position: relative;
          top: -1px;
        }
        /deep/ .match {
          color: $primary;
        }
      }
      .operation {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 300px;
        .audio {
          display: inline-block;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
          font-size: 16px;
          i {
            color: $primary;
            font-size: 24px;
            position: relative;
            top: -2px;
          }
        }
        .star {
          position: absolute;
          right: 0;
        }
      }
    }
    .score-wrap {
      display: flex;
      justify-content: center;
      height: 40px;
      line-height: 40px;
      text-align: center;
      span {
        margin: 0 10px;
      }
      .star {
        margin: 0 20px;
      }
    }
    .tip {
      p {
        line-height: 1.4;
        text-align: center;
      }
    }
  }
</style>
